import { render, staticRenderFns } from "./add-house-type.vue?vue&type=template&id=0582bdf8&scoped=true&"
import script from "./add-house-type.vue?vue&type=script&lang=js&"
export * from "./add-house-type.vue?vue&type=script&lang=js&"
import style0 from "./add-house-type.vue?vue&type=style&index=0&id=0582bdf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0582bdf8",
  null
  
)

export default component.exports